
/**
 *
 * @param {JQuery} target - экземпляр кнопки
 * @param {JQuery} actionsWindow - экземпляр модального окна
 */
export const emailCampaignsModalActionsListners = (target, actionsWindow) => {
    const campaign_id = $(target).data('id');
    const email_id = $(target).data('email_id');
    const audience_id = $(target).data('audience_id');

    actionsWindow.find('.show_progress_modal').data('id', campaign_id);
    actionsWindow.find('#view_email_modal_btn').data('email_id', email_id);
    if (target.parent().find('.campaign_status').text() === 'Draft') {
        actionsWindow.find('.edit_email_btn').removeClass('d-none');
        actionsWindow.find('.edit_audience_btn').removeClass('d-none');
        actionsWindow.find('.edit_email_btn').attr('href', `/email-department/email-designing-text?email_id=${email_id}&campaign_id=${campaign_id}`);
        actionsWindow.find('.edit_audience_btn').attr('href', `/email-department/email-department-promotional?audience_id=${audience_id}&campaign_id=${campaign_id}`);
    }else{
        actionsWindow.find('.edit_email_btn').addClass('d-none');
        actionsWindow.find('.edit_audience_btn').addClass('d-none');
    }
    if (target.parent().find('.campaign_status').text() === 'Draft' || target.parent().find('.campaign_status').text() === 'Scheduled') {
        actionsWindow.find('.edit_campaign_btn').removeClass('d-none');
        actionsWindow.find('.edit_campaign_btn').attr('href', `/email-department/new-campaign?audience_id=${audience_id}&campaign_id=${campaign_id}&email_id=${email_id}`);
    } else {
        actionsWindow.find('.edit_campaign_btn').addClass('d-none');
    }
    actionsWindow.find('.view_emails_list').data('campaign_id', campaign_id);
    if (target.parent().find('.campaign_status').text() === 'Draft') {
        actionsWindow.find('.delete_campaign_btn').removeClass('d-none');
        actionsWindow.find('.delete_campaign_btn').data('campaign_id', campaign_id);
    } else {
        actionsWindow.find('.delete_campaign_btn').addClass('d-none');
    }
    actionsWindow.find('.test_email_btn').data('email_id', email_id);

}
